module.exports = __webpack_public_path__ + "static/img/14010106.7d4bccc6.png";